import mixpanel from 'mixpanel-browser';
import { initializeGoogleTagManager } from './gtm';


export function initializeTrackers() {
  const mixpanelActive = String(process.env.REACT_APP_MIXPANEL_ACTIVE || '').toLowerCase() === 'true';
  const gtmActive = String(process.env.REACT_APP_GTM_TRACKING_ACTIVE || '').toLowerCase() === 'true';

  if (mixpanelActive) {
    try {
      mixpanel.init(process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN, { debug: true });
    } catch (_) {}
  }

  if (gtmActive) {
    try {
      initializeGoogleTagManager();
    } catch (_) {}
  }
}
